import React from 'react';
import Grid from '@mui/material/Grid2';
import { Link, Tooltip } from '@mui/material';
import axios from 'axios';
import {
    Box,
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import { filesExtToContentTypes } from '../../../utils/common';
import { contentTypeArr } from '../../../utils/common';
const Questionnaire = (props) => {

    const {policyData} = props;

    const [questionnaire, setQuestionnaire] = React.useState([]);

    React.useEffect(() => {

        if (policyData?.pa_forms) {
            setQuestionnaire(policyData?.pa_forms);
        }

    }, [policyData]);

    // const previewFile = (event, fileSrc, fileName="", isDownload=false) => {
    //     event.preventDefault()
    //     if (fileSrc) {
    //         console.log('fileSrc', fileSrc)
    //         props.setOpenLoader(true);

    //         let fileContentType = filesExtToContentTypes(fileName);

    //         (async () => {
    //             const res = await fetch(fileSrc.url)
    //             const fileData = await res.arrayBuffer()          
    //             let previewFileURL = URL.createObjectURL(new Blob([fileData], {
    //                 type: fileContentType
    //         })) ;
            
    //         props.setOpenLoader(false)

    //         if (isDownload) {
    //             let a = document.createElement("a");
    //             document.body.appendChild(a);
    //             a.style = "display: none";

    //             a.href = previewFileURL;
    //             a.download = fileName;
    //             a.click();
    //             window.URL.revokeObjectURL(previewFileURL);
    //         }
    //         else {
    //             window.open(previewFileURL);
    //         }
    //         })()
              
    //     }
    // };

    const openPdf = (url, fileName) => {
        let contentType = '';
        // if (url.endsWith('.pdf')) contentType = 'application/pdf';
        // else if (url.endsWith('.doc')) contentType = 'application/msword';
        // else if (url.endsWith('.docx')) contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        // else if (url.endsWith('.xls')) contentType = 'application/vnd.ms-excel';
        // else if (url.endsWith('.xlsx')) contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        // else if (url.endsWith('.ppt')) contentType = 'application/vnd.ms-powerpoint';
        // else if (url.endsWith('.pptx')) contentType = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        // else if (url.endsWith('.csv')) contentType = 'text/csv; charset=utf-8';
        // else if (url.endsWith('.txt')) contentType = 'text/plain; charset=utf-8';
        // else if (url.endsWith('.json')) contentType = 'application/json';
        // else if (url.endsWith('.jpg') || url.endsWith('.jpeg')) contentType = 'image/jpeg';
        // else if (url.endsWith('.png')) contentType = 'image/png';
        // else if (url.endsWith('.gif')) contentType = 'image/gif';
        // else if (url.endsWith('.webp')) contentType = 'image/webp';
        // else if (url.endsWith('.svg')) contentType = 'image/svg+xml';
        // else if (url.endsWith('.zip')) contentType = 'application/zip';
        // else if (url.endsWith('.mp3')) contentType = 'audio/mpeg';
        // else if (url.endsWith('.mp4')) contentType = 'video/mp4';
        contentTypeArr.forEach( (val) => {
            if (url.endsWith(val.ext)) {
                contentType = val.cnt;
            }
        });

        axios.get(url, {
            responseType: 'blob',
            headers: {
                Accept: contentType
            }
            })
            .then((res) => {
                const blob = new Blob([res.data], { type: contentType });
                const pdfUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = pdfUrl;
                link.target = '_blank';
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // cleanup
                URL.revokeObjectURL(pdfUrl);
            })
            .catch(console.error);
    };

    return (
        <Box>
            {questionnaire && questionnaire.length>0 && (<><h3 className="sectionHeading" style={{marginTop: '5px'}}>QUESTIONNAIRE</h3>
            <div className="preview-header-section">
                { questionnaire.length===0 ? <p>No Data</p> : 
                (<ul style={{ listStyle: 'disc', "marginLeft": "15px", "paddingLeft": "0", marginTop: '0', marginBottom: '0' }}>
                    {
                        questionnaire.map( (a, index) => {
                            
                            return (
                                <li key={index} style={{"paddingBottom":"3px", "marginLeft": "0", "paddingLeft": "0"}}>
                                    <Grid container spacing={2}>
                                        <Grid item >
                                            <Link 
                                                onClick={(event) => {
                                                    // previewFile(event, a.url, a.title);
                                                    openPdf(a?.url, a.title);
                                                }}
                                                style={{"cursor":"pointer"}}
                                            >
                                                {`${a.title}`} 
                                            </Link>
                                        </Grid>
                                        <Grid item >
                                            <Tooltip title="Download File">
                                                <Link 
                                                    onClick={(event) => {
                                                        // previewFile(event, a.url, a.title, true);
                                                        openPdf(a?.url, a.title);
                                                    }}
                                                    style={{"cursor":"pointer"}}
                                                >
                                                    <FileDownloadIcon />
                                                </Link>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </li>
                            )

                        })
                    }
                </ul>)
                }
            </div></>)}
        </Box>
    )

}

export default Questionnaire;